import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import TabPanel from "../../elements/tab/materialTabPanel";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import queryString from "query-string";

import { StyledContentWrapper } from "../../styles/styledMain";
import { StyledWalletsWrapper } from "../styledWallets";
import { StyledTabsBody, StyledTabsHead } from "../../styles/styledTabs";
import WalletsContainer from "./walletList/WalletsContainer";
import ReservedBalanceHistoryContainer from "./reservedBalanceHistory/ReservedBalanceHistoryContainer";

const DEFAULT_TAB = "walletList";

const WalletsTabsContainer = ({ match }) => {
  const { t } = useTranslation("walletsPage");

  const history = useHistory();

  let queryParams = queryString.parse(history.location.search);

  const urlForTabs = () => {
    if (!queryParams.currentTab) {
      return 0;
    }

    switch (queryParams.currentTab) {
      case "walletList": {
        return 0;
      }
      case "reservedBalance": {
        return 1;
      }
    }
  };

  const tabValue = urlForTabs();

  const handleChange = (event, newValue) => {
    if (queryParams.currentTab !== newValue) {
      history.push("?currentTab=" + newValue);
    }
  };

  return (
    <StyledContentWrapper>
      <StyledWalletsWrapper>
        <StyledTabsHead
          className="tab-head"
          orientation="horizontal"
        >
          <Tabs
            value={queryParams?.currentTab ?? DEFAULT_TAB}
            indicatorColor="secondary"
            onChange={handleChange}
            orientation="horizontal"
            className="tab-head-buttons"
            variant="scrollable"
            scrollButtons="auto"
          >
            <Tab label={t("tabs.wallets")} value="walletList" />
            <Tab label={t("tabs.reserve")} value="reservedBalance" />
          </Tabs>
        </StyledTabsHead>
        <StyledTabsBody className="tab-body">
          <TabPanel
            value={tabValue}
            index={0}
          >
            <WalletsContainer match={match} t={t} />
          </TabPanel>
          <TabPanel
            value={tabValue}
            index={1}
          >
            <ReservedBalanceHistoryContainer match={match} t={t} />
          </TabPanel>
        </StyledTabsBody>
      </StyledWalletsWrapper>
    </StyledContentWrapper>
  );
};

export default WalletsTabsContainer;